const NIGHTWEB_APP_CONSTANT = {
  userIdleTime: 1800,
  migrationTimeout: 120000,
  timeout: 30,
  showLimits: [
    { label: 'Show 20', value: 20 },
    { label: 'Show 50', value: 50 },
    { label: 'Show 100', value: 100 },
  ],
  defaultDate: '01/01/1900',
  defaultDatePipeFormat: 'MM/dd/yyyy',
  defaultDateFormat: 'MM/dd/YYYY',
  defaultMomentDateFormat: 'MM/DD/YYYY',
  defaultTimeFormat: 'hh:mm a',
  shorTimeFormat: 'hh:mm',
  defaultDateTimeFormat: 'MM/dd/yyyy - hh:mm a',
  shortDateTimeFormat: 'MM/dd/yyyy hh:mm a',
  defaultSubmitDateFormat: 'YYYY-MM-DD',
  mdbDefaultDateFormat: 'mm/dd/yyyy',
  dateMask: [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/],
  defaultPercentPipe: '',
  modalConfig: {
    animation: true,
    backdrop: true,
    data: {
      title: '',
      body: '',
      formData: {},
      confirmButtonLabel: '',
    },
    ignoreBackdropClick: true,
    keyboard: true,
    modalClass: 'modal-lg',
  },
  confirmPopConfig: {
    position: 'left',
    data: {
      title: '',
      body: '',
      confirmButtonLabel: '',
      cancelButtonLabel: 'Cancel',
    },
  },
  skeletonLoaderConfig: {
    'border-radius': '0',
    height: '10px',
    margin: '0px',
  },
  inputLimit: {
    priceSeparatorLimit: '99999999999999',
    personNameMask: 'S* S*',
  },
  phonePattern: { '0': { pattern: new RegExp('^[0-9]*$') } },
  passwordPattern:
    /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@@$%^&*-]).{8,}$/,
  passwordMinLength: 8,
  phoneMask: '(000) 000-0000',
  emailPattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  zipPattern: /^[0-9]{5}$/,
  defaultLimit: 20,
  defaultOffset: 1,
  debounceTime: 300,
  /**
   * Poll interval (ms) for the AxisLink dual-party live map while it is open. Lowered from 30s to
   * 10s for now, for fast local testing against the NEX-1534 mock — raise back to something in
   * the 20-30s range before this hits real backend traffic in production.
   */
  threatPairLiveMapRefreshMs: 10000,
  /**
   * AxisLink zone model (BFRD §8.1/FR-102/FR-103): Red Zone = emergency radius, Yellow Zone =
   * warning radius, both centred on the Protected Party (Survivor). Only a single radius
   * (`ThreatPair.distanceThreshold`) exists on the pairing today, so it is treated as the Red
   * Zone radius and the Yellow Zone is derived from it until the backend adds a dedicated
   * Yellow-radius config field (FR-102). `axisLinkFallbackRedZoneRadiusMeters` is the BFRD's
   * illustrative default, used only if a pairing somehow has no `distanceThreshold`.
   */
  axisLinkFallbackYellowZoneRadiusMeters: 200,
  axisLinkFallbackRedZoneRadiusMeters: 100,
  /**
   * Mock-only (NEX-1534): no backend endpoint exists yet for Monitored Subject (perpetrator)
   * GPS. The mocked location orbits the Protected Party's position over this period so the
   * live map visibly crosses the Yellow/Red zones during a session. Remove once the real
   * perpetrator location API lands.
   */
  axisLinkMockPerpetratorOrbitPeriodMs: 120000,
  /**
   * FR-502: how stale the Protected Party's fix may be before the zone centre is flagged
   * low-confidence on the display. BFRD OQ-05 (blocks development) leaves the real threshold
   * unresolved with the client — this is a placeholder (15 minutes) until confirmed.
   */
  axisLinkFallbackPositionStalenessMs: 15 * 60 * 1000,
  /**
   * FR-206/BR-012/NFR-03: hysteresis margin applied when *leaving* a zone, so a subject sitting on
   * a boundary doesn't flip state on every check-in. OQ-10 leaves open whether hysteresis is a
   * distance margin, a dwell duration, or both; the client's own geo-proximity simulation answers
   * it as a distance margin, mirrored here until confirmed.
   *
   * Expressed as a fraction of each ring's own radius rather than a flat meter value — the sim's
   * example (50m against 500m/1000m radii) is a reasonable ~5-10%, but applied as a flat 50m to a
   * pairing configured with small radii (e.g. 50m/100m) it exceeds the ring's own size and the
   * zone state can feel stuck for a very noticeable while after a party visibly leaves the ring.
   */
  axisLinkZoneHysteresisBufferFraction: 0.1,
  /** Floor so hysteresis stays meaningful even for a very small configured radius. */
  axisLinkZoneHysteresisMinMeters: 3,
  /**
   * Dead-band (m/s) below which a closing rate reads as "holding steady" rather than closing or
   * opening — matches the client's simulation.
   */
  axisLinkClosingRateDeadbandMps: 0.05,
  defaultBrandName: 'Samsung',
  defaultOS: 'Wear OS 5.0',
  defaultRoleId: '63be68153a670a046603a4fe',
  genderList: ['Male', 'Female', 'Other'],
  defaultLimitSelectWidth: '110px',
  roles: {
    SUPER_ADMIN: 'SUPER_ADMIN',
    ADVOCATE: 'ADVOCATE',
    CLIENT_ADMIN: 'CLIENT_ADMIN',
    DEVICE_ADMIN: 'DEVICE_ADMIN',
    END_USER: 'END_USER',
  },
};

export { NIGHTWEB_APP_CONSTANT };
